export default __webpack_public_path__ + "cc37f7ba8d3c52d11119f75550f66efc.png";